import Nullstack from 'nullstack';
export default function IconClothesRackOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-clothes-rack-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M12 7v1m0 4v9"
  }), "   ", Nullstack.element("path", {
    d: "M9 21h6"
  }), "   ", Nullstack.element("path", {
    d: "M7.757 9.243a6 6 0 0 0 3.129 1.653m3.578 -.424a5.999 5.999 0 0 0 1.779 -1.229"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}